import { toast, ToastContent } from "react-toastify";

const styling = { fontSize: "14px", fontWeight: 600, fontFamily: "Roboto", borderRadius: "12px", lineHeight: "20px" };

// react-toastify uses toastId to dedupe; passing the same id while a toast is open
// suppresses duplicates. Use the text itself as the id so identical messages collapse.
const toastIdFor = (text: ToastContent<unknown>) => (typeof text === "string" ? `toast-${text}` : undefined);

export const showInfo = (text: ToastContent<unknown>) =>
  toast.info(text, {
    autoClose: 3000,
    style: styling,
    toastId: toastIdFor(text),
  });

export const showSuccess = (text: ToastContent<unknown>) =>
  toast.success(text, {
    autoClose: 3000,
    style: styling,
    toastId: toastIdFor(text),
  });

export const showWarning = (text: ToastContent<unknown>) =>
  toast.warn(text, {
    autoClose: 3000,
    style: styling,
    toastId: toastIdFor(text),
  });

export const showError = (text: ToastContent<unknown>) =>
  toast.error(text, {
    autoClose: 3000,
    style: styling,
    toastId: toastIdFor(text),
  });
